import { Product } from "..";

export interface ProductView extends Product {
  ProductCategoryIds: string;
  ProductBrandId: string;
  VendorId: string;
}
